import React, { createContext, useState, useMemo, useContext, useCallback } from 'react';
import { dashboardService } from '../services/DashboardService';

export const DashboardContext = createContext();

export const DashboardProvider = props => {
    const [dashboard, setDashboard] = useState([]);
    

    const getDashboard = useCallback((startDate, endDate) => {
        setDashboard(dashboardService.getDashboard(startDate, endDate));
        return dashboardService.getDashboard(startDate, endDate);
    }, []);
 
    const values = useMemo(
        () => ({
            dashboard,
            getDashboard
        }),
        [
            dashboard,
            getDashboard
        ]
    );

    return <DashboardContext.Provider value={values}>{props.children}</DashboardContext.Provider>;
};

export const useDashboard = () => {
    
    const context = useContext(DashboardContext);;

    if (context === undefined) {
        throw new Error('useDashboard must be used within a DashboardProvider component.');
    } 

    return context;
};
